/**
 * Candidate Import Page
 *
 * Wrapper page for the Candidate Import Wizard
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography, Breadcrumbs, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import CandidateImportWizard from "../components/CandidateImportWizard/CandidateImportWizard";

const CandidateImportPage: React.FC = () => {
  const { t } = useTranslation(["recruiting", "common"]);

  return (
    <Box sx={{ p: 3 }}>
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link
          component={RouterLink}
          to="/candidates"
          color="inherit"
          underline="hover"
        >
          {t("import.page.breadcrumbs.candidates")}
        </Link>
        <Typography color="text.primary">
          {t("import.page.breadcrumbs.import")}
        </Typography>
      </Breadcrumbs>

      <Typography variant="h4" gutterBottom>
        {t("import.page.title")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t("import.page.description")}
      </Typography>

      <CandidateImportWizard />
    </Box>
  );
};

export default CandidateImportPage;
